// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__c7zdB","notes":"Notes_notes__3-GRa","note":"Notes_note__1dP10","markdown":"Notes_markdown__2RAdu"};